// Group V. 片語與非謂語 Phrases and Non-finites
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group5Data = {
  id: "group_5",
  title: {
    tc: "片語與非謂語",
    sc: "短语与非谓语",
    en: "Phrases and Non-finites"
  },
  subtitle: {
    tc: "Phrases and Non-finites",
    sc: "Phrases and Non-finites",
    en: "Phrases and Non-finites"
  },
  icon: "📝",
  difficulty: "intermediate",
  color: "from-yellow-500 to-yellow-600",
  topics: [
    {
      id: "infinitive_purpose",
      title: {
        tc: "不定詞（目的）",
        sc: "不定词（目的）",
        en: "Infinitive of Purpose"
      },
      description: {
        tc: "學習表示目的的不定詞用法",
        sc: "学习表示目的的不定词用法",
        en: "Learn the usage of infinitives to express purpose"
      },
      icon: "🎯",
      difficulty: "intermediate",
      examples: [
        {
          id: "inf_purpose_1",
          sentence: "She went to the store to buy milk.",
          analysis: "She (S) went (V) to the store (M) to buy (M-purpose) milk (O).",
          translation: {
            tc: "她去商店買牛奶。",
            sc: "她去商店买牛奶。",
            en: "She went to the store to buy milk."
          }
        },
        {
          id: "inf_purpose_2",
          sentence: "He called to ask a question.",
          analysis: "He (S) called (V) to ask (M-purpose) a question (O).",
          translation: {
            tc: "他打電話問問題。",
            sc: "他打电话问问题。",
            en: "He called to ask a question."
          }
        },
        {
          id: "inf_purpose_3",
          sentence: "I moved here to study.",
          analysis: "I (S) moved (V) here (M) to study (M-purpose).",
          translation: {
            tc: "我搬到這裡學習。",
            sc: "我搬到这里学习。",
            en: "I moved here to study."
          }
        },
        {
          id: "inf_purpose_4",
          sentence: "We stayed late to finish the work.",
          analysis: "We (S) stayed (V) late (M) to finish (M-purpose) the work (O).",
          translation: {
            tc: "我們待得很晚來完成工作。",
            sc: "我们待得很晚来完成工作。",
            en: "We stayed late to finish the work."
          }
        },
        {
          id: "inf_purpose_5",
          sentence: "She paused to think.",
          analysis: "She (S) paused (V) to think (M-purpose).",
          translation: {
            tc: "她停下來思考。",
            sc: "她停下来思考。",
            en: "She paused to think."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：to-V 表目的/意圖；放句尾自然。",
        sc: "要点：to-V 表目的/意图；放句尾自然。",
        en: "Key points: to-V expresses purpose/intention; naturally placed at the end of sentences."
      }
    },
    {
      id: "gerund_subject",
      title: {
        tc: "動名詞作主語",
        sc: "动名词作主语",
        en: "Gerund as Subject"
      },
      description: {
        tc: "學習動名詞作為主語的用法",
        sc: "学习动名词作为主语的用法",
        en: "Learn the usage of gerunds as subjects"
      },
      icon: "📚",
      difficulty: "intermediate",
      examples: [
        {
          id: "gerund_subj_1",
          sentence: "Swimming is fun.",
          analysis: "Swimming (S) is (V) fun (C).",
          translation: {
            tc: "游泳很有趣。",
            sc: "游泳很有趣。",
            en: "Swimming is fun."
          }
        },
        {
          id: "gerund_subj_2",
          sentence: "Reading broadens the mind.",
          analysis: "Reading (S) broadens (V) the mind (O).",
          translation: {
            tc: "閱讀開闊思維。",
            sc: "阅读开阔思维。",
            en: "Reading broadens the mind."
          }
        },
        {
          id: "gerund_subj_3",
          sentence: "Traveling alone can be rewarding.",
          analysis: "Traveling alone (S) can be (V) rewarding (C).",
          translation: {
            tc: "獨自旅行可能很有收穫。",
            sc: "独自旅行可能很有收获。",
            en: "Traveling alone can be rewarding."
          }
        },
        {
          id: "gerund_subj_4",
          sentence: "Exercising regularly helps health.",
          analysis: "Exercising regularly (S) helps (V) health (O).",
          translation: {
            tc: "定期運動有益健康。",
            sc: "定期运动有益健康。",
            en: "Exercising regularly helps health."
          }
        },
        {
          id: "gerund_subj_5",
          sentence: "Learning English opens doors.",
          analysis: "Learning English (S) opens (V) doors (O).",
          translation: {
            tc: "學習英語開啟機會。",
            sc: "学习英语开启机会。",
            en: "Learning English opens doors."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：V-ing 名詞化；學術文可用名詞化提升凝練度。",
        sc: "要点：V-ing 名词化；学术文可用名词化提升凝练度。",
        en: "Key points: V-ing nominalization; academic writing can use nominalization to improve conciseness."
      }
    },
    {
      id: "participial_constructions",
      title: {
        tc: "分詞構句",
        sc: "分词构句",
        en: "Participial Constructions"
      },
      description: {
        tc: "學習分詞構句的用法和結構",
        sc: "学习分词构句的用法和结构",
        en: "Learn the usage and structure of participial constructions"
      },
      icon: "🔗",
      difficulty: "advanced",
      examples: [
        {
          id: "participle_1",
          sentence: "Feeling tired, he went home.",
          analysis: "Feeling tired (M), he (S) went (V) home (M).",
          translation: {
            tc: "感到疲憊，他回家了。",
            sc: "感到疲惫，他回家了。",
            en: "Feeling tired, he went home."
          }
        },
        {
          id: "participle_2",
          sentence: "Not knowing what to do, she asked for help.",
          analysis: "Not knowing what to do (M), she (S) asked (V) for help (O).",
          translation: {
            tc: "不知道該怎麼辦，她求助了。",
            sc: "不知道该怎么办，她求助了。",
            en: "Not knowing what to do, she asked for help."
          }
        },
        {
          id: "participle_3",
          sentence: "Built in 1890, the house still stands.",
          analysis: "Built in 1890 (M), the house (S) still (M) stands (V).",
          translation: {
            tc: "建於1890年，這房子仍然屹立。",
            sc: "建于1890年，这房子仍然屹立。",
            en: "Built in 1890, the house still stands."
          }
        },
        {
          id: "participle_4",
          sentence: "Having finished, they left early.",
          analysis: "Having finished (M), they (S) left (V) early (M).",
          translation: {
            tc: "完成後，他們提早離開了。",
            sc: "完成后，他们提早离开了。",
            en: "Having finished, they left early."
          }
        },
        {
          id: "participle_5",
          sentence: "Considering the risks, we declined.",
          analysis: "Considering the risks (M), we (S) declined (V).",
          translation: {
            tc: "考慮到風險，我們拒絕了。",
            sc: "考虑到风险，我们拒绝了。",
            en: "Considering the risks, we declined."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：分詞片語作狀語；邏輯主語需與主句 S 對應，避免懸垂。",
        sc: "要点：分词短语作状语；逻辑主语需与主句 S 对应，避免悬垂。",
        en: "Key points: participial phrases as adverbials; logical subject must correspond to main clause S, avoid dangling participles."
      }
    },
    {
      id: "post_modifying_participles",
      title: {
        tc: "後置分詞修飾",
        sc: "后置分词修饰",
        en: "Post-modifying Participles"
      },
      description: {
        tc: "學習後置分詞作為修飾語的用法",
        sc: "学习后置分词作为修饰语的用法",
        en: "Learn the usage of post-modifying participles"
      },
      icon: "📝",
      difficulty: "intermediate",
      examples: [
        {
          id: "post_mod_1",
          sentence: "People living nearby were evacuated.",
          analysis: "People (S) living nearby (Post-mod) were evacuated (V-pass).",
          translation: {
            tc: "住在附近的人被疏散了。",
            sc: "住在附近的人被疏散了。",
            en: "People living nearby were evacuated."
          }
        },
        {
          id: "post_mod_2",
          sentence: "The documents requested are attached.",
          analysis: "The documents (S) requested (Post-mod) are (V) attached (C).",
          translation: {
            tc: "要求的文件已附上。",
            sc: "要求的文件已附上。",
            en: "The documents requested are attached."
          }
        },
        {
          id: "post_mod_3",
          sentence: "The man standing there is my uncle.",
          analysis: "The man (S) standing there (Post-mod) is (V) my uncle (C).",
          translation: {
            tc: "站在那裡的男人是我叔叔。",
            sc: "站在那里的男人是我叔叔。",
            en: "The man standing there is my uncle."
          }
        },
        {
          id: "post_mod_4",
          sentence: "The issues discussed remain unresolved.",
          analysis: "The issues (S) discussed (Post-mod) remain (V-link) unresolved (C).",
          translation: {
            tc: "討論的問題仍然未解決。",
            sc: "讨论的问题仍然未解决。",
            en: "The issues discussed remain unresolved."
          }
        },
        {
          id: "post_mod_5",
          sentence: "The road leading to the lake is closed.",
          analysis: "The road (S) leading to the lake (Post-mod) is (V) closed (C).",
          translation: {
            tc: "通往湖邊的路被封閉了。",
            sc: "通往湖边的路被封闭了。",
            en: "The road leading to the lake is closed."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：現在/過去分詞作後置定語；相當於縮減的關係子句。",
        sc: "要点：现在/过去分词作后置定语；相当于缩减的关系子句。",
        en: "Key points: present/past participles as post-modifiers; equivalent to reduced relative clauses."
      }
    }
  ]
};
